import { z } from "zod";
import {
  ACCOUNT_NAME,
  APPROVED_AMT,
  BANK_ACCOUNT,
  BANK_CHARGES,
  BASELINE_DATE,
  CHEQUE_NO,
  DEDUCTION_AMT,
  DOC_NO,
  DOC_TYPE,
  DOCUMENT_ID,
  DOCUMENT_TYPE,
  DRCR,
  DUE_DATE,
  HEADER_TEXT,
  INVOICE_AMT,
  INVOICE_DATE,
  INVOICE_NO,
  INVOICE_REF,
  LINE_ITEMS,
  PAY_BLOCK,
  PAYABLE_AMT,
  PAYMENT_AMOUNT,
  PAYMENT_DATE,
  POSTING_DATE,
  RESIDUAL,
  TARGET_VENDOR_SUBLEDGER_ID,
  VENDOR_ID,
} from "./consts";

export const schema = z.object({
  [DOCUMENT_TYPE]: z.string().optional(),
  [DOCUMENT_ID]: z.string().optional(),
  [VENDOR_ID]: z.string().min(1, "This field is required"),
  [BANK_ACCOUNT]: z.string().min(1, "This Field is required"),
  [POSTING_DATE]: z.any(),
  [ACCOUNT_NAME]: z.string().min(1, "This field is required"),
  [PAYMENT_AMOUNT]: z.string().min(1, "This field is required"),
  [CHEQUE_NO]: z.string().optional(),
  [PAYMENT_DATE]: z.any(),
  [BANK_CHARGES]: z.string().optional(),
  [DEDUCTION_AMT]: z.string().optional(),
  [LINE_ITEMS]: z
    .object({
      [INVOICE_DATE]: z.string().optional(),
      [INVOICE_NO]: z.string().optional(),
      [INVOICE_REF]: z.string().optional(),
      [DOC_NO]: z.string().optional(),
      [DOC_TYPE]: z.string().optional(),
      [HEADER_TEXT]: z.string().optional(),
      [BASELINE_DATE]: z.string().optional(),
      [DUE_DATE]: z.string().optional(),
      [PAY_BLOCK]: z.string().optional(),
      [DRCR]: z.string().optional(),
      [INVOICE_AMT]: z.string().optional(),
      [APPROVED_AMT]: z.string().optional(),
      [PAYABLE_AMT]: z.string().optional(),
      [RESIDUAL]: z.string().optional(),
      [TARGET_VENDOR_SUBLEDGER_ID]: z.string().optional(),
    })
    .array(),
});

export type formValues = z.infer<typeof schema>;
